module.exports = __webpack_public_path__ + "media/icons/discussion_message_icon-ac63de27.png";